import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * GlobalHealth icon
 *
 * @category Medical
 */
const GlobalHealth = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="m27.17 15.38-.08-.1c-.21-3.05-1.63-6.02-4.33-7.96l-.14-.1C16.57 2.79 7.25 6.04 5.54 13.41c-2.42 8.69 6.71 16.55 14.95 12.93.47-.19.92-.4 1.34-.66 4.62.31 9.42-4.83 5.34-10.3m-1-.94c-1.63-1.26-3.59-1.48-5.34-.97v-.04c-.14-1.04-.37-2.09-.55-3.09-.13-.92.72-1.56 1.54-1.7 1.98-.36 3.96 3.49 4.35 5.8m-8.86 1.48h-.01c-1.02-.01-2.07-.07-3.01-.03-1.09 0-1.76.04-1.97-.39l-.05-.11c-.21-1 .12-2.49.3-3.57.15-1.02.68-1.94 1.89-1.82 1.42.32 3.43-.37 4.63.3.83.85.84 2.21.99 3.38 0 .02 0 .04.01.06-1.1.46-2.08 1.22-2.78 2.18m-.74 5.64c.06.13.12.26.18.38h-.03l-.44-.06h-.19c-2.19.12-3.38.62-3.64-1.87-.09-1.33-.75-3.05.41-3.34 1.25-.09 2.67-.05 4.01-.04-.75 1.39-.96 3.1-.3 4.93m2.06-15.05c.86.14 2.03.64 2.79 1.09.64.38-1.18.98-1.51 1.05l-.11-.02c-.24-.17-.52-.95-.78-1.28-.25-.4-.7-.85-.39-.84m-2.51-.3h.13c1.01.03 2.66 1.64 2.56 2.59-.58.6-1.77.39-2.63.49-.87-.06-1.84.02-2.55-.38-.49-.78 1.57-2.76 2.49-2.7m-4.78 1.18c.71-.35 1.75-.82 2.5-.91l.03.03c-.12.3-.68.98-.87 1.41-.18.32-.29.65-.52.69-.38 0-1.46-.4-1.63-.79-.01-.15.21-.29.49-.43M9.94 8.6h.16c1.12-.02 2.34.89 1.95 2.12-.4 1.4-.47 3.1-.76 4.54-.28.7-.89.64-1.68.67-.82 0-1.8.03-2.61-.03-2.69-.13 1.42-7.33 2.94-7.3m-3.77 8.36.05-.1c.17-.24.59-.3 1.24-.3 1.04.06 2.37-.15 3.37.16.8.28.58 2.04.84 3.13.34 1.62.77 3.05-1.24 3.63-2.37.72-4.53-4.85-4.26-6.52m4.34 7.53c-.2-.28.44-.55.89-.78.49-.25 1.1-.53 1.3.14l.07.15c.12.47 1.08 1.63 1.05 1.9-.92-.04-2.59-.8-3.31-1.41m3.44.15c-.84-1.13-.82-1.77.75-1.86.42-.02 1.47-.12 2.43-.08h.04c.42.68.9 1.24 1.43 1.67-1.21 1.96-3.11 2.65-4.65.27m4.82 1.25c-.45.11-.17-.23.13-.64.1-.12.2-.28.29-.45.36.24.74.42 1.13.56-.52.23-1.06.41-1.55.53m4.72-1.31-.11.02h.01l-.47.06c-.43.04-.84.04-1.23-.02a4.65 4.65 0 0 1-2.03-.75 4 4 0 0 1-.53-.4c-.03-.02-.05-.05-.08-.06-.02-.03-.05-.05-.07-.07-.14-.12-.26-.25-.39-.39-1.48-1.71-1.86-4.36-.59-6.35.16-.26.34-.5.56-.73.41-.44.93-.83 1.56-1.14h.04c.03-.02.06-.03.09-.04 2.58-1.06 4.885-.112 6.185 1.378 2.26 2.61 1.971 7.242-2.799 8.492z"
        />
        <rect
          width="2.659"
          height="2.659"
          x="19.959"
          y="15.89"
          fill="currentColor"
          rx="1.329"
        />
        <path
          fill="currentColor"
          d="M23.567 22.59c.19 0 .346.155.346.346v.372a.347.347 0 0 1-.693 0v-.372c0-.19.156-.346.347-.346m-1.148-.272a.347.347 0 0 1 .49.49l-.262.264a.346.346 0 0 1-.49-.49zm1.807 0a.347.347 0 0 1 .49 0l.262.263a.347.347 0 0 1-.49.49l-.262-.263a.346.346 0 0 1 0-.49m-1.935-1.004a.347.347 0 0 1 0 .693h-.372a.347.347 0 0 1 0-.693zm2.925 0a.347.347 0 0 1 0 .693h-.372a.347.347 0 0 1 0-.693zm-3.06-1.065a.347.347 0 0 1 .49 0l.263.264a.347.347 0 0 1-.49.49l-.263-.264a.347.347 0 0 1 0-.49m2.332 0a.347.347 0 0 1 .49.49l-.264.263a.347.347 0 0 1-.49-.49zm-.921-.584c.191 0 .346.155.346.346v.372a.346.346 0 0 1-.693 0v-.372c0-.191.156-.346.347-.346"
        />
        <path
          fill="currentColor"
          d="M22.237 21.66a1.33 1.33 0 1 1 2.66 0 1.33 1.33 0 0 1-2.66 0m2.261-3.398a.665.665 0 1 1 1.33 0 .665.665 0 0 1-1.33 0"
        />
        <rect
          width="1.329"
          height="1.329"
          x="19.294"
          y="19.958"
          fill="currentColor"
          rx=".665"
        />
        <path
          fill="currentColor"
          d="M21.636 18.496a.347.347 0 0 0-.693 0v.372a.347.347 0 0 0 .693 0zm-1.004-.618a.35.35 0 0 0-.491 0l-.262.262a.346.346 0 0 0 .49.49l.263-.263a.35.35 0 0 0 0-.49m1.805-.001a.347.347 0 0 0-.49.49l.263.264a.347.347 0 0 0 .49-.49zm-2.078-.656a.347.347 0 0 0-.347-.346h-.372a.346.346 0 0 0 0 .692h.372a.35.35 0 0 0 .347-.346m2.925-.001a.347.347 0 0 0-.346-.347h-.372a.347.347 0 0 0 0 .693h.372a.347.347 0 0 0 .346-.347m-2.916-1.409a.347.347 0 0 0-.49.49l.263.263a.35.35 0 0 0 .49 0 .35.35 0 0 0 0-.49zm2.332 0a.347.347 0 0 0-.49 0l-.264.262a.347.347 0 0 0 .49.49l.264-.262a.347.347 0 0 0 0-.49m-1.065-.239a.346.346 0 0 0-.693 0v.373a.347.347 0 0 0 .693 0z"
        />
      </svg>
    );
  }
);

GlobalHealth.displayName = 'GlobalHealth';

export { GlobalHealth };
